import { mapGetters } from 'vuex'
import FooterComponent from '@/components/commons/footer/FooterComponent.vue'
import NavbarComponent from '@/components/commons/navbar/NavbarComponent.vue'
import DialogComponent from '@/components/commons/dialog/DialogComponent.vue'
import SnackbarComponent from '@/components/commons/snackbar/SnackbarComponent.vue'
import SearchTools from '@/components/search/ToolSearch.vue'
import { ColvenTheme } from '@/constants/constants'
import ReportBugComponent from '@/components/report-bug/ReportBugComponent.vue'
import { authService } from '@/services/auth.service'

export default {
  components: {
    FooterComponent,
    NavbarComponent,
    SnackbarComponent,
    DialogComponent,
    SearchTools,
    ReportBugComponent
  },
  computed: {
    ...mapGetters({
      'getDisplayHeader': 'app/getDisplayHeader',
      'getDark': 'app/getDark',
      'getToken': 'user/getToken',
      'getThemes': 'user/getThemes'
    })
  },
  methods: {
    /**
     * Elimina la caché guardada de la página
     */
    async updateUI() {
      this.showUpdateUI = false
      await this.$workbox.messageSW({ type: "SKIP_WAITING" })
    }
  },
  beforeMount() {
    // Carga los temas
    if (this.getThemes) {
      this.$vuetify.theme.themes.light = this.getThemes.light
      this.$vuetify.theme.themes.dark = this.getThemes.dark
    } else {
      this.$vuetify.theme.themes.light = ColvenTheme.light
      this.$vuetify.theme.themes.dark = ColvenTheme.dark
    }
    this.$vuetify.theme.dark = this.getDark
  },
  async created() {
    /**
     * Si se detectó un cambio de versión, se muestra el snackbar
     */
    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", () => {
        this.showUpdateUI = true
      });
    }

    await authService.refreshSessionData()
  },
  mounted() {
    // Setea el lenguaje de los componentes de Vuetify
    this.$vuetify.lang.current = this.$i18n.locale

    // La siguiente validación de token fue comentada en la implementación de la recuperación de contraseña (PAGRO-1240)
    /*
    if (!this.getToken) {
      this.$router.push('login');
    }
    */
  },
  data: () => ({
    // para activar el prompt de actualización de versión
    showUpdateUI: false
  })
};
